const LOGIN_PATH = '/login'

/**
 * Build SSO login URL and inject runtime redirect_uri.
 * Priority: NEXT_PUBLIC_AUTH_REDIRECT_URI > current origin + /login.
 */
export const getAuthLoginUrl = (): string => {
	const authUrl = process.env.NEXT_PUBLIC_AUTH_URL
	if (!authUrl) {
		return LOGIN_PATH
	}

	if (typeof window === 'undefined') {
		return authUrl
	}

	const runtimeRedirectUri = `${window.location.origin}${LOGIN_PATH}`
	const redirectUri = process.env.NEXT_PUBLIC_AUTH_REDIRECT_URI || runtimeRedirectUri

	try {
		const loginUrl = new URL(authUrl)
		loginUrl.searchParams.set('redirect_uri', redirectUri)
		return loginUrl.toString()
	} catch (error) {
		console.warn('Invalid NEXT_PUBLIC_AUTH_URL, fallback to raw value.', error)
		return authUrl
	}
}

export const redirectToAuthLogin = (): void => {
	if (typeof window === 'undefined') {
		return
	}

	window.location.href = getAuthLoginUrl()
}

